import axios from 'axios';

export class B2bClient {
    /**
     * @param data
     * @return {Promise<*>}
     */
    async send(data) {
        const url = `b2b.php?page=2`
        const response = await axios.post(url, {
            params: data,
            responseType: 'text'
        });

        return response.data;
    }
}
